import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { withCookies } from 'react-cookie';
import jwtDecode from 'jwt-decode';
import Favicon from 'react-favicon';

import {
  NAVSTATES,
  CONSTANTS,
  REDIRECT_URL,
  ASSET_PREFIX
} from './config/constants';
import {
  createQuiz,
  changeState,
  continueQuiz,
  initApp,
  fetchTags,
  fetchExamTags,
  fetchDashboardStats,
  fetchNotesFlagged,
  updateAuth,
  toggleNav,
  fetchHistory,
  updateApp
} from './actions';
import Header from './containers/Header';
import Navbar from './containers/Navbar';
import Dashboard from './containers/Dashboard';
import QuizHistory from './containers/QuizHistory';
import Quiz from './containers/Quiz';
import DefaultView from './components/Loading';
import Walkthrough from './containers/Features';
import Init from './containers/Init';
import Footer from './components/Footer';
import Settings from './containers/Settings';
import FirstRun from './containers/FirstRun';
import './styles/App.css';
import Raven from 'raven-js';

injectTapEventPlugin();

const intervalPeriod = 500; // in ms

const currentState = {};

let pathfix = window.location.href.slice(8).split('/');
pathfix.splice(0, 1);
pathfix = `/${pathfix.join('/')}`;

if (window.location.href.indexOf('?') > -1) {
  const temp = window.location.href
    .slice(8, window.location.href.indexOf('?'))
    .split('/');
  temp.splice(0, 1);
  pathfix = `/${temp.join('/')}`;
  window.history.replaceState('', '', pathfix);
}

const product =
  CONSTANTS.PRODUCT_ID[
    window.location.href.split('/')[
      window.location.href.split('/').length - 1
    ] ||
      window.location.href.split('/')[
        window.location.href.split('/').length - 2
      ]
  ];

class App extends Component {
  constructor(props) {
    super(props);

    Raven.config('https://4b0477c1af664c9bb1a615b091410037@sentry.io/185432', {
      dataCallback: data => {
        data.extra.app = currentState.app;
        data.extra.quiz = currentState.quiz;
        data.extra.stats = currentState.stats;
        data.extra.currentState = currentState.currentState;
        return data;
      }
    }).install();

    this.state = {
      height: 0,
      authToken: null
    };

    this.states = {
      firstRun: () => <FirstRun params={this.props.params} />,
      init: () => <Init params={this.props.params} />,
      walkthrough: () => <Walkthrough params={this.props.params} />,
      quiz: () => <Quiz params={this.props.params} />,
      dashboard: () => <Dashboard params={this.props.params} />,
      history: () => <QuizHistory params={this.props.params} />,
      settings: () => <Settings params={this.props.params} />
    };

    window.onpopstate = event => {
      if (event.state) {
        this.props.changeState(event.state, { back: true });
      } else if (this.props.params && !this.props.params.back) {
        window.history.back();
      }
    };

    this.interval = null;

    this.checkSession = this.checkSession.bind(this);
    this.resetSession = this.resetSession.bind(this);
  }

  componentWillMount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    // Cookies don't have change events, we need to check periodically.
    this.interval = setInterval(this.checkSession, intervalPeriod);
    this.checkSession();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  checkSession() {
    const { cookies } = this.props;

    const cookie = cookies ? cookies.get('hippo-session') : null;
    if (cookie) {
      const { access_token, refresh_token } = cookie.authenticated;
      const expires_at = cookie.authenticated.expires_at ||
        // This app doesn't support the new auth flow yet. If you're testing locally,
        // get your token from somewhere else. e.g. video-platform-client/web
        // new auth flow puts expiration in the token, not in the cookie
        // and token exp is seconds since Epoch but Date.getTime() is in millis
        (jwtDecode(access_token).exp * 1000)

      if (expires_at < new Date().getTime()) {
        this.resetSession();
      } else if (access_token && expires_at) {
        this.props.updateAuth(access_token, refresh_token, expires_at);
      }
    }
  }

  resetSession() {
    window.location = REDIRECT_URL + pathfix;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.authToken === null && nextProps.authToken !== null) {
      this.props
        .initApp(product ? product.shortname : product)
        .then(() => {
          this.props.fetchTags();
          this.props.fetchExamTags();
          this.props.fetchHistory(true);
        })
        .catch(err => console.log(err));
    }
    if (
      nextProps.params &&
      !nextProps.params.back &&
      this.props.currentState !== nextProps.currentState
    ) {
      const nextState = nextProps.currentState;
      if (NAVSTATES[nextState]) {
        window.history.pushState(nextState, '', '');
      }
    }

    if (this.props.currentState !== nextProps.currentState) {
      window.scrollTo(0, 0);
    }

    if (
      this.props.currentState !== 'history' &&
      (this.props.user === null ||
        this.props.tagsLoading === true ||
        this.props.examTagsLoading === true) &&
      nextProps.user &&
      nextProps.tagsLoading === false &&
      nextProps.examTagsLoading === false
    ) {
      clearInterval(this.interval);
      if (this.props.currentState !== 'dashboard') {
        this.props.fetchDashboardStats(nextProps.user);
        if (this.devMode) {
          this.props
            .createQuiz(
              ['bef3de36-1be0-4bc6-bbc8-6209e67652d6'],
              [],
              30,
              'practice'
            )
            .then(() => {
              this.props.changeState('quiz');
            });
        } else if (nextProps.newFeatures) {
          this.props.changeState('walkthrough', {
            firstRun: nextProps.firstRun
          });
        } else if (!nextProps.newFeatures && nextProps.firstRun) {
          this.props.updateApp({ intro: true }).then(() => {
            this.props.changeState('firstRun');
          });
        } else {
          this.props.changeState('init');
        }
      } else if (this.props.user && nextProps.user === null) {
        this.props.changeState('default');
      }

      if (!this.props.product && nextProps.product && !product) {
        const temp = window.location.href
          .slice(
            8,
            window.location.href.indexOf('?') > -1
              ? window.location.href.indexOf('?')
              : window.location.href.length
          )
          .split('/');
        const product = temp.splice(temp.length - 2, 1);
        const path = `${
          pathfix && pathfix !== '/' && pathfix[pathfix.length - 1] !== '/'
            ? '/'
            : ''
        }${
          Object.keys(CONSTANTS.PRODUCT_ID).filter(p => p === product[0]).length
            ? product[0]
            : Object.keys(CONSTANTS.PRODUCT_ID).filter(
                name => CONSTANTS.PRODUCT_ID[name].id === nextProps.product
              )[0]
        }`;
        window.history.replaceState('', '', `${pathfix}${path}`);
      }
    }
  }

  initializeQuiz(tags, examTags, count, mode) {
    this.props.changeState('loading').then(() => {
      this.props
        .createQuiz(tags, examTags, count, mode)
        .then(() => this.props.changeState('quiz'));
    });
  }

  render() {
    return (
      <div
        className="App mobile-wrapper"
        style={this.state.height ? { height: this.state.height } : {}}
      >
        {window.location.href
          .split('/')
          .splice(-1, 1)[0]
          .toLowerCase() === 'peds' ||
        ASSET_PREFIX[this.props.product] === 'peds' ? (
          <Favicon url="https://files.slack.com/files-pri/T02GZB9GE-F6WMJNYQK/peds-qbank-favicon.png" />
        ) : window.location.href
            .split('/')
            .splice(-1, 1)[0]
            .toLowerCase() === 'pa' ||
          ASSET_PREFIX[this.props.product] === 'pa' + '' ? (
          <Favicon url="https://files.slack.com/files-pri/T02GZB9GE-F87HCJFR6/download/pa-favicon.ico" />
        ) : null}
        <div
          className="hide-not-mobile mobile-nav"
          style={
            this.props.navOpen
              ? { left: 0, opacity: 100 }
              : { left: '-50%', opacity: 0 }
          }
        >
          {!this.props.intro &&
          this.props.user &&
          this.props.currentState &&
          this.props.currentState !== 'walkthrough' &&
          this.props.currentState !== 'firstRun' ? (
            <Navbar />
          ) : null}
        </div>
        <div
          className={`App-main${
            this.props.navOpen ? ' main-app-mobile-nav-open' : ''
          }`}
          onTouchTap={() =>
            this.props.navOpen ? this.props.toggleNav() : null
          }
          style={this.props.navOpen ? { left: '50%' } : {}}
        >
          <Header params={{ pathfix }} />
          {!this.props.intro &&
          this.props.user &&
          this.props.currentState &&
          this.props.currentState !== 'walkthrough' &&
          this.props.currentState !== 'firstRun' ? (
            <div className="hide-mobile">
              <Navbar />
            </div>
          ) : null}
          <MuiThemeProvider>
            {(() =>
              this.states[this.props.currentState] ? (
                this.states[this.props.currentState]()
              ) : (
                <DefaultView loading={this.props.tagsLoading} />
              ))()}
          </MuiThemeProvider>
          <Footer />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  Object.assign(currentState, {
    app: state.app,
    quiz: state.quiz,
    stats: state.stats,
    currentState: state.currentState
  });

  const newFeatures = state.app
    ? state.app.newFeatures
      ? state.app.newFeatures.length > 0
      : false
    : false;
  const user = state.app ? state.app.user : null;
  const navOpen = state.app ? state.app.navOpen : null;
  const settings = state.app ? state.app.settings : null;
  const isTrial = user ? user.isTrial : null;
  const app = state.app || {};
  const firstRun = !(
    user &&
    user.validProfForProduct &&
    settings &&
    user[CONSTANTS.FIRST_RUN_FIELDS.TRAINING_LEVEL] &&
    ((settings.values[CONSTANTS.FIRST_RUN_FIELDS.EXAM_TYPE] &&
      settings.values[CONSTANTS.FIRST_RUN_FIELDS.EXAM_DATE]) ||
      settings.values[CONSTANTS.FIRST_RUN_FIELDS.SPECIALTY])
  );

  return {
    tagsLoading: state.tags ? !!state.tags.tagsLoading : null,
    examTagsLoading: state.examTags ? !!state.examTags.tagsLoading : null,
    currentState: state.currentState ? state.currentState.state : null,
    params: state.currentState ? state.currentState.params : null,
    intro: app.intro,
    authToken: state.auth ? state.auth.accessToken : null,
    product: app.product,
    newFeatures,
    user,
    navOpen,
    settings,
    firstRun,
    isTrial
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createQuiz,
      changeState,
      continueQuiz,
      initApp,
      fetchTags,
      fetchExamTags,
      fetchDashboardStats,
      fetchNotesFlagged,
      updateAuth,
      toggleNav,
      fetchHistory,
      updateApp
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(App));



// WEBPACK FOOTER //
// ./src/App.js